export const SIGNALR_RECONNECT_INTERVALS_MS = [0, 2000, 10000, 30000] as const;
export const SIGNALR_IDLE_TIMEOUT_MINUTES = 3;
